import { Spin } from 'antd';
import { getSystemFlags } from 'core/core.selectors';
import type { PestManagementSection } from 'pages/sugarcane/pest-management.routes';
import { buildPestManagementPath, PestManagementSections } from 'pages/sugarcane/pest-management.routes';
import { lazyRoute } from './lazy-route';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';

const Sugarcane = lazyRoute(() => import('pages/sugarcane/sugarcane.container'));

type SugarcaneSectionPath = typeof PestManagementSections.RISK | typeof PestManagementSections.CONTROL_STRATEGY;

const useBorerRiskPath = () => {
  const { companyId, propertyId } = useParams();
  return `/company/${companyId}/property/${propertyId}/borer-risk`;
};

export const PestManagementSectionRoute = ({ section }: { section: SugarcaneSectionPath }) => {
  const systemFlags = useSelector(getSystemFlags);
  const borerRiskPath = useBorerRiskPath();

  if (!systemFlags) {
    return <Spin fullscreen />;
  }

  if (!systemFlags.P40_61940_pest_management_submenu) {
    return <Navigate replace to={borerRiskPath} state={{ key: section === PestManagementSections.RISK ? '1' : '2' }} />;
  }

  return (
    <Suspense fallback={<Spin fullscreen />}>
      <Sugarcane section={section} />
    </Suspense>
  );
};

export const BorerRiskRoute = () => {
  const systemFlags = useSelector(getSystemFlags);
  const { companyId, propertyId } = useParams();

  if (!systemFlags) {
    return <Spin fullscreen />;
  }

  if (systemFlags.P40_61940_pest_management_submenu) {
    return <Navigate replace to={buildPestManagementPath(companyId, propertyId, PestManagementSections.CONTROL_STRATEGY)} />;
  }

  return (
    <Suspense fallback={<Spin fullscreen />}>
      <Sugarcane />
    </Suspense>
  );
};

export const LegacyRoutingRedirect = ({ section }: { section: PestManagementSection }) => {
  const { companyId, propertyId } = useParams();
  const { search, state } = useLocation();

  return <Navigate replace to={{ pathname: buildPestManagementPath(companyId, propertyId, section), search }} state={state} />;
};
